<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="Basic-Paragraph ParaOverride-1" lang="en-US"><span class="CharOverride-1" lang="">Eloise Bruce is a mother of two, living in Hampshire in the UK. She had a long career as a primary school teacher and has been working in social and therapeutic horticulture for the past 5 years. Eloise is passionate about getting children learning outdoors and helping them to develop their social and emotional skills through a strong connection with nature. In her spare time, Eloise can be found pottering around in the garden, watching the birds and squirrels through the window or wandering about in the woods.</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781398495401_EPUB2.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
</div>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer005">
<p class="Copyright ParaOverride-2" lang="en-US">Copyright © Eloise Bruce 2024</p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">The right of </span><span class="CharOverride-3" lang="">Eloise Bruce </span><span class="CharOverride-2" lang="">to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">A CIP catalogue record for this title is available from the British Library.</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">ISBN 9781398495401 (Paperback)</span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">ISBN 9781398495418 (ePub e-book)</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">www.austinmacauley.co.uk</span></p>
<p class="Basic-Paragraph ParaOverride-3" lang="en-US"><span class="CharOverride-2" lang="">First Published 2024</span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">Austin Macauley Publishers Ltd® </span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">1 Canada Square</span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">Canary Wharf</span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">London</span></p>
<p class="Basic-Paragraph ParaOverride-4" lang="en-US"><span class="CharOverride-2" lang="">E14 5AA</span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Author-bio" lang="en-US">To nature and all it teaches us</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="Graphic" lang="en-US"><img alt="" class="_idGenObjectAttribute-1" src="image/9781398495401_EPUB7.jpg"/></p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer009">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer010">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB1.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer011">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer012">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB3.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer013">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer014">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB4.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer015">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB5.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer017">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB6.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer019">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB8.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB9.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB10.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB11.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB12.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB13.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB14.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB15.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB16.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB17.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB18.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer041">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB19.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer043">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB20.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer045">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB21.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer047">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB22.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer049">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB23.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer051">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB24.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer053">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB25.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer054">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB26.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB27.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB28.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer060">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer061">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB29.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer062">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB30.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB31.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB32.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB33.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer070">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer071">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB34.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer072">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer073">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB35.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer074">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer075">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer076">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB36.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer077">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer078">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB37.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer079">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer080">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB38.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer081">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer082">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB39.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer083">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer084">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB40.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer085">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer086">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB41.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer087">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer088">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB42.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer089">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer090">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB43.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer091">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer092">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB44.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer093">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer094">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB45.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer095">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer096">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB46.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer097">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer098">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB47.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer099">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer100">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB48.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer101">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer102">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB49.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer103">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer104">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB50.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer105">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer106">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB51.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer107">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer108">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB52.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer109">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer110">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB53.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer111">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer112">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB54.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer113">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer114">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB55.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer115">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer116">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB56.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer117">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer118">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB57.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer119">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer120">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB58.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer121">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer122">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB59.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer123">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer124">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB60.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer125">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer126">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB61.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer127">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer128">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB62.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer129">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer130">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB63.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer131">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer132">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB64.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer133">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer134">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB65.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer135">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer136">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB66.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer137">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer138">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB67.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer139">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer140">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB68.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer141">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer142">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB69.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer143">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer144">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB70.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer145">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer146">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB71.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer147">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer148">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB72.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer149">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer150">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB73.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer151">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer152">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB74.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer153">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer154">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB75.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer155">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer156">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB76.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer157">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer158">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB77.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer159">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB78.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer160">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer161">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB79.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer162">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer163">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB80.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer164">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer165">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB81.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer166">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer167">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB82.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer168">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer169">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB83.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer170">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer171">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB84.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer172">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer173">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB85.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer174">
</div>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer175">
<img alt="" class="_idGenObjectAttribute-2" src="image/9781398495401_EPUB86.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenObjectStyleOverride-1" id="_idContainer176">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// New_EPUB.vue?23434648